"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETEReportingDataSource = void 0;
/* eslint-disable @typescript-eslint/no-empty-interface */
var ETEReportingDataSource;
(function (ETEReportingDataSource) {
    ETEReportingDataSource["SCHEDULE_GENERATOR"] = "SCHEDULE_GENERATOR";
    ETEReportingDataSource["RESERVATIONS"] = "RESERVATIONS";
    ETEReportingDataSource["ORDERS"] = "ORDERS";
    ETEReportingDataSource["EXAMS"] = "EXAMS";
    ETEReportingDataSource["FORMS"] = "FORMS";
    ETEReportingDataSource["ACTIVITIES"] = "ACTIVITIES";
})(ETEReportingDataSource = exports.ETEReportingDataSource || (exports.ETEReportingDataSource = {}));
